import { render, staticRenderFns } from "./Proxy.vue?vue&type=template&id=2f9688bd&"
import script from "./Proxy.vue?vue&type=script&lang=js&"
export * from "./Proxy.vue?vue&type=script&lang=js&"
import style0 from "./Proxy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports